import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import {LoadingService} from "../../shared/utils/loading.service";
import {EXCLUDE_SPINNER} from "../../shared/utils/exclude-spinner.token";

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  const shouldExclude = req.context.get(EXCLUDE_SPINNER);

  if (!shouldExclude) {
    loadingService.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (!shouldExclude) {
        loadingService.hide();
      }
    })
  );
};
